import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions } from '../../../../models/Utils';

import { ADALandmarks, ADAARIARoles } from '../../../../models/ADA';

import LearnMoreLink from '../../../Common/LearnMoreLink/LearnMoreLink';

import './BottomSection.scss';

const BottomSection = React.forwardRef(({ data, sectionHeight, hideFromADA }, theRef) => {
  const menuOpened = useSelector(state => state.data.menuOpened);

  return (
    <div
      className="credo-outro-container"
      ref={theRef}
      role={ADAARIARoles.Group}
      aria-label={`Section: ${data.BigText}`}
      style={{
        visibility: hideFromADA ? 'hidden' : null
      }}
    >
      <div className="cpvi-grid-container">
        <div className="cpvi-grid-row">
          <div className="cpvi-grid-col w12">
            <div className="credo-content-holder" style={{ height: `${sectionHeight}px`}}>
              <div className="credo-content-wrapper">
                <div className="credo-big-text" role={ADAARIARoles.Heading}>{data.BigText}</div>
                <LearnMoreLink
                  className="credo-button"
                  text={data.Link.Text}
                  external={true}
                  to={data.Link.Link}
                  specialAltText={data.Link.SpecialAltText}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default BottomSection;